import { useState } from "react";
import {
  legacyPushResultOffices,
  legacySystemSmsPresets,
} from "../../mock/legacySms";
import "./LegacySystemSmsPreset.css";

const codes = [
  "고객번호 [Mock 고객번호]",
  "수신자 [Mock 수신자]",
  "수신연락처 [Mock 연락처]",
  "보호자 [Mock 보호자]",
  "아기이름 [Mock 아기]",
  "촬영날짜 [Mock 촬영일]",
  "촬영시각 [Mock 촬영시각]",
  "오늘날짜 [Mock 오늘]",
  "스튜디오 표시 명칭 [Mock 스튜디오]",
  "일정제목 [Mock 일정제목]",
];
function byteCount(value: string) {
  return Array.from(value).reduce(
    (total, char) => total + (char.charCodeAt(0) > 127 ? 2 : 1),
    0,
  );
}

export function LegacySystemSmsPreset() {
  const [office, setOffice] = useState<string>(legacyPushResultOffices[0]);
  const [contents, setContents] = useState(() =>
    Object.fromEntries(
      legacySystemSmsPresets.map((item) => [item.id, item.defaultContent]),
    ),
  );
  const [openId, setOpenId] = useState<string | null>(null);
  const [previewId, setPreviewId] = useState<string | null>(null);
  const [notice, setNotice] = useState<string | null>(null);
  const selectOffice = (value: string) => {
    setOffice(value);
    const query = new URLSearchParams({
      page_start: "1",
      page_count: "30",
      page_no: "1",
      is_show: "0",
      office_id:
        value === legacyPushResultOffices[0]
          ? "mock-office-01"
          : "mock-office-02",
    });
    window.history.replaceState({}, "", `${window.location.pathname}?${query}`);
  };
  const insertCode = (id: string, code: string) =>
    setContents((current) => ({
      ...current,
      [id]: `${current[id]}${code.slice(code.indexOf("["))}`,
    }));
  return (
    <div className="legacy-m07">
      <h1 className="g_title">시스템 문자 발송 설정</h1>
      <aside className="g_filter_wrap l_filter_width">
        <div className="g_input_wrap">
          <label className="g_label title center">지점</label>
          <select
            id="office_select"
            className="g_input width_2x l_office_select"
            value={office}
            onChange={(event) => selectOffice(event.target.value)}
          >
            {legacyPushResultOffices.map((item) => (
              <option key={item}>{item}</option>
            ))}
          </select>
        </div>
      </aside>
      <div className="g_text comment_box">
        각 메시지별 코드 선택 가능한 치환 코드만 치환됩니다.
      </div>
      <section className="l_preset_form_container">
        {legacySystemSmsPresets.map((preset) => {
          const content = contents[preset.id];
          const bytes = byteCount(content);
          const type = bytes > 90 ? "LMS" : "SMS";
          return (
            <article className="l_form_section" key={preset.id}>
              <form
                className="g_card l_preset_form"
                onSubmit={(event) => {
                  event.preventDefault();
                  setNotice(
                    `Mock '${preset.category}' 설정이 저장되었습니다. 실제 문자·PUSH·API 호출은 발생하지 않았습니다.`,
                  );
                }}
              >
                <div className="l_category_wrap">
                  <p className="l_preset_category">{preset.category}</p>
                </div>
                <div className="l_content_header">
                  <button
                    className="g_btn size_1 l_preset_open_code"
                    type="button"
                    onClick={() =>
                      setOpenId((value) =>
                        value === preset.id ? null : preset.id,
                      )
                    }
                  >
                    코드선택
                  </button>
                </div>
                <div className="l_content_func_wrap">
                  {openId === preset.id && (
                    <div className="g_card g_card_modal l_code_layer open">
                      <button
                        className="g_btn icon close_popup"
                        type="button"
                        aria-label="코드 선택 닫기"
                        onClick={() => setOpenId(null)}
                      >
                        ×
                      </button>
                      <span className="g_text comment l_code_comment">
                        * 버튼클릭시 치환코드가 메세지에 삽입됩니다.
                        <br />각 메시지별 선택 가능한 치환 코드만 치환됩니다.
                      </span>
                      <div className="l_code_btn_container">
                        {codes.map((code) => (
                          <button
                            className="g_btn size_2"
                            type="button"
                            key={code}
                            onClick={() => insertCode(preset.id, code)}
                          >
                            {code}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                  <textarea
                    className="g_input l_preset_text"
                    value={content}
                    onChange={(event) =>
                      setContents((current) => ({
                        ...current,
                        [preset.id]: event.target.value,
                      }))
                    }
                    required
                  />
                </div>
                <div className="l_content_status_wrap">
                  <span className={`l_status_type ${type.toLowerCase()}`}>
                    {type}
                  </span>
                  <span className="l_status_byte">
                    {bytes}/{type === "SMS" ? 90 : 2000}
                  </span>
                </div>
                <div className="g_func_wrap l_func_btn_wrap">
                  <button
                    className="g_btn save g_btn_submit l_func_btn"
                    type="submit"
                  >
                    저장
                  </button>
                  <button
                    className="g_btn l_func_btn l_preview_btn"
                    type="button"
                    onMouseEnter={() => setPreviewId(preset.id)}
                    onMouseLeave={() => setPreviewId(null)}
                  >
                    미리보기
                  </button>
                  <div
                    className={`ui-tooltip l_preview_layer${previewId === preset.id ? " show" : ""}`}
                  >
                    Mock 치환 결과 미리보기
                  </div>
                  <button
                    className="g_btn delete l_func_btn"
                    type="button"
                    onClick={() => {
                      setContents((current) => ({
                        ...current,
                        [preset.id]: preset.defaultContent,
                      }));
                      setNotice("Mock 기본 메시지로 초기화했습니다.");
                    }}
                  >
                    초기화
                  </button>
                </div>
              </form>
            </article>
          );
        })}
      </section>
      {notice && (
        <div className="m07-notice">
          {notice}
          <button type="button" onClick={() => setNotice(null)}>
            ×
          </button>
        </div>
      )}
    </div>
  );
}
